import { ApolloCache } from '@apollo/client';
import { DocumentNode } from '@apollo/client/link/core/types';
import { getQueryFields } from '@e2m-customer-portal/shared';

/**
 * Returns an update function for GraphQL operations that will clear the cache for all given other GraphQL operations.
 * @param docs
 */
export function clearCache(...docs: DocumentNode[]): (cache: ApolloCache<unknown>) => void {
  return (cache) => {
    docs
      .flatMap((document) => getQueryFields(document))
      .forEach((fieldName) =>
        cache.evict({
          id: 'ROOT_QUERY',
          fieldName,
        }),
      );
    cache.gc();
  };
}
